import { useEffect, useRef, useState } from "react";
import {  SiteData } from "../Data/SiteData";
import { GetHistoryList, GetLayoutFromHistoryId, RestoreHistory } from "../Utilities/PageDataHandler";

import StaticRender from "../StaticRender";
import LayoutNode from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import generateGlobalStyleFromSiteData from "vagaro-website-rendering/src/components/Utilities/GenerateGlobalStyleFromSiteData";
import { IncludeCustomFonts } from "../RenderSiteStyle";
import { ScreenSize } from "vagaro-website-rendering/src/components/Definitions/ScreenSize";
import { AlertConfirm, Confirmation } from "../ConfirmationPopups";
import Loader from "components/Common/Loader";
import { DesktopIcon, MobileIcon, TabletIcon } from "../Icons/ScreenSizeIcons";
import SelectDropdown from "../SelectDropdown";
import { CreatePageDataFromAPI } from "../WebDesignerManager";
import { LoginUserType } from "utils/Utils";



// function formatCustomDate(date:Date) {
//     // Months array to map numeric month to its name
//     const months = [
//       'Jan', 'Feb', 'Mar', 'Apr',
//       'May', 'Jun', 'Jul', 'Aug',
//       'Sep', 'Oct', 'Nov', 'Dec'
//     ];
  
//     // Get month, day, year
//     const month = months[date.getMonth()];
//     const day = date.getDate();
//     const year = date.getFullYear();
  
//     // Get hours and minutes
//     const hours = date.getHours();
//     const minutes = date.getMinutes();
  
//     // AM or PM
//     const ampm = hours >= 12 ? 'PM' : 'AM';
  
//     // Convert hours to 12-hour format
//     const formattedHours = hours % 12 || 12;
  
//     // Format the date string
//     const formattedDate = `${month} ${day}, ${year} ${formattedHours}:${minutes.toLocaleString('en-US', {minimumIntegerDigits: 2})} ${ampm}`;
  
//     return formattedDate;
//   }

  const HistoryList = ({versionData,siteData,loadHistoryByVersion,selectedVersion}:{versionData:any,siteData:SiteData,loadHistoryByVersion:Function,selectedVersion:string|null})=>{

    if(versionData&&versionData.length==0){

        return <div style={{padding:"8px"}}>No History Available</div>
    }

    versionData.sort((a:any,b:any)=>{
        let da = new Date(a.createdDate??"");
        let db = new Date(b.createdDate??"");

        return  db.getTime() - da.getTime() ;
    });

    return <div>
    {
        versionData.map((ver:any)=>{         
            // let dateObj = new Date(ver.createdDate??"");


            if(ver.isAdmin && siteData.userContext.userType != LoginUserType.VagaroAdmin){
                ver.createdName = "Vagaro Admin";
                ver.intials = "VA";
                ver.photoURL = "https://abecce03c3734f0f373c-0fea70e615f2fb09d042c0473fadcf2c.ssl.cf2.rackcdn.com/Websitebuilder/20240122193551.png";
            }

            return <div key={ver.id} className={"version-history-box "+(ver.id==selectedVersion?"selected":"") }

                onClick={()=>{loadHistoryByVersion(ver.id)}}
            
                >

                    <div className="font-bold" style={{fontSize:"16px",marginBottom:"4px"}}>{ver.strCreatedDate}</div>
                    <div className="flex-row gap-med">
                        {ver.photoURL?
                        <div className="history-avatar" style={{backgroundImage:`url(${ver.photoURL})`}}></div>:
                        <div className="history-avatar center-all" >{ver.intials??"NA"}</div>

                        }
                        <div className="text-truncate">{ver.createdName}{ver.isAdmin && siteData.userContext.userType == LoginUserType.VagaroAdmin && <span className="badge black-bedge" style={{background:"#000", marginLeft: "5px"}}>Vagaro</span>}</div>
                    </div>
                </div>

        })
    }    
    </div>
}


export default function VersionHistoryMenu({siteData,onDismiss,onSelectVersion}:{siteData:SiteData,onDismiss?:Function,onSelectVersion?:(ver:string)=>void}){

    const [versionData,setVersionData] = useState<any>(null);
    const [loadedData,setLoadedData] = useState<any>(null);
    const [selectedVersion,setSelectedVersion] = useState<string|null>(null);
    const [loadedPageId,setLoadedPageId] = useState<string>("");
    const screenSize = useRef<ScreenSize>(ScreenSize.Desktop);
    const [isLoading,setIsLoading] = useState<boolean>(false);

    const previewScreenRef = useRef<HTMLDivElement>(null);
    const screenSizeContainerRef = useRef<HTMLDivElement>(null);

    useEffect(()=>{

         GetHistoryList(siteData.userContext,(data)=>{
            setVersionData(data);

            if(selectedVersion==null&&data.length>0){
                loadHistoryByVersion(data[0].id);
            }
        
        },(err)=>{
            setVersionData("error");
        })


//eslint-disable-next-line
    },[])
    const loadHistoryByVersion = (ver:string)=>{
        setLoadedData("loading");
        setSelectedVersion(ver);
        GetLayoutFromHistoryId(siteData.userContext,ver,(data)=>{

            if(data.pages){
                data.pages = data.pages.filter((pg:any)=>pg.isSoftDeleted!==true);
            }

            setLoadedData(data);

            let pages = data.pages;

            if(loadedPageId!=""){ // if this page exisits in the next version leave it...
                for(let i = 0;i<pages.length;i++){
                    if(pages[i].pageId===loadedPageId){
                        return;
                    }
                }
            }

            for(let i = 0;i<pages.length;i++){
                if(pages[i].isHomePage){
                  
                        setLoadedPageId(pages[i].pageId);
                        return;
                    
                  
                }
            }
            setLoadedPageId(""); 

       
        },(err)=>{
            setLoadedData("error");
        })

    }


    const changePageByURL = (url:string)=>{


        if(loadedData&&loadedData.pages){

            const pgs = loadedData.pages;
            for(let i = 0;i<pgs.length;i++){
                if(pgs[i].urlSlug==="/"+url || (url=="./"&&pgs[i].isHomePage)){
                    setLoadedPageId(pgs[i].pageId);
                    break;
                }
            }
        }
    }

    const HistoryPreviewScreen = ({pageId}:{pageId:string})=>{

 

        if(!loadedData||!loadedData.layout||!loadedData.layout.content){
            return <div>No Data</div>
        }

        let styling = JSON.parse(loadedData.layout.content).styling;

        let header = JSON.parse(loadedData.layout.header) as LayoutNode;

        let footer = JSON.parse(loadedData.layout.footer) as LayoutNode;

        const newData = {...siteData}
        newData.siteStyling = styling;
        let pages = loadedData.pages;
        if(!pages||pages.length==0){
            return <div>No Pages</div>
        
        }

        //CreatePageDataFromAPI expects data.data.data so create a wrapper to pass the pages array
        const pageWrapper =  {
              data:{
                data: pages  }
        }

        let newPageData =  CreatePageDataFromAPI(pageWrapper,siteData)
        
        newData.pages = newPageData;
        newData.userContext = {...siteData.userContext};
        newData.userContext.pages = newPageData;
        
       

        let previewPage = pages.find((pg:any)=>pg.pageId===pageId);

        if(!previewPage){
            for(let i = 0;i<pages.length;i++){
                if(pages[i].isHomePage){
                    previewPage = pages[i];
                    break;
                }
            }
        }

        if(!previewPage){
            return <div>No Valid Pages</div>
        }

        let rootLayout = (previewPage.content)?JSON.parse(previewPage.content) as LayoutNode:new LayoutNode() ;
        if(!rootLayout.typename)
            rootLayout.typename = wBComponentTypeNames.pageRoot;

        rootLayout.children = [header,...rootLayout.children,footer]

  
        let styl =  document.getElementById("site-main-styling");
        if(styl){
            styl.innerHTML = "";
        }


        let maxWidth = "2500px";
        if(screenSize.current === ScreenSize.Tablet){
            maxWidth = "769px";
        }
        else if(screenSize.current === ScreenSize.Mobile){
            maxWidth = "400px";
        }

        return (
          <>
            <style
              id="history-site-main-styling"
              dangerouslySetInnerHTML={{
                __html: generateGlobalStyleFromSiteData(styling),
              }}
            ></style>
            <IncludeCustomFonts siteData={newData} />
            <div ref={previewScreenRef} className="history-preview w-full scrollable h-full" style={{maxWidth:maxWidth,transition:".3s"}}>
                <style>
                    {`
                        .cta-container{
                           display:none !important;
                        }
                    `}
                </style>
            <StaticRender
              siteData={newData}
              userContext={newData.userContext}
              root={rootLayout}
              onChangePageOverride={changePageByURL}
            ></StaticRender>
            </div>
          </>
        );


    }

    const changeSize = ( newSize:ScreenSize )=>{

        screenSize.current =  newSize;

        if(previewScreenRef.current&&screenSizeContainerRef.current){

            let queryKey = "desktop";
            let width = "2500px";
            switch(newSize){
                case ScreenSize.Desktop:
                    queryKey = "desktop";
                    width = "2500px";
                    break;
                case ScreenSize.Tablet:
                    queryKey = "tablet";
                    width = "769px";
                    break;
                case ScreenSize.Mobile:
                    queryKey = "mobile";
                    width = "400px";
                    break;
            

            }

            screenSizeContainerRef.current.querySelectorAll(".preview-option").forEach((el)=>{
                el.classList.remove("selected");
            });

            screenSizeContainerRef.current.querySelector("."+queryKey)?.classList.add("selected");

            previewScreenRef.current.style.maxWidth = width;

        

            

        }

    }

    const ScreenSizeSelector = ()=>{

        return <div ref={screenSizeContainerRef} className="flex-row center-all" style={{ position:"absolute",top:"16px",left:"0",width:"100%",paddingLeft:"240px" }}>

        <button className={"desktop preview-option center-all invisible-button " + (screenSize.current == ScreenSize.Desktop ? "selected" : "")} onClick={() =>{changeSize(ScreenSize.Desktop)}} ><DesktopIcon /></button>
        <button className={"tablet preview-option center-all invisible-button " + (screenSize.current == ScreenSize.Tablet ? "selected" : "")} onClick={() =>{changeSize(ScreenSize.Tablet)}} ><TabletIcon /></button>
        <button className={"mobile preview-option center-all invisible-button " + (screenSize.current == ScreenSize.Mobile ? "selected" : "")} onClick={() =>{changeSize(ScreenSize.Mobile)}} ><MobileIcon /></button>

    </div>
    }

    const PageSelector = ()=>{

        if(!loadedData||!loadedData.pages){
            return <></>
        }

        let options:{label:string,value:string}[] = [];

        for(let i = 0;i<loadedData.pages.length;i++){
            if(!loadedData.pages[i].isFolder)
            options.push({label:loadedData.pages[i].pageName,value:loadedData.pages[i].pageId})
        }

        options.sort((a,b)=>{ return a.label.localeCompare(b.label)});

        return    <div className="flex-row" style={{position:"absolute",left:"300px",top:"12px",fontWeight:"normal",fontSize:"16px"}}>
        <span style={{color:"#9A9A9A",fontWeight:"normal"}}>Page:</span>
    
        <SelectDropdown key={selectedVersion} options={options} defaultValue = {loadedPageId} expandToRight={true} 
        onChange={(value:string)=>{
            setLoadedPageId(value);
        }} />

    </div>

    }

    const RestoreButton =()=>{

        let disabled = (!loadedData||loadedData ==="loading"||loadedData==="error"||!selectedVersion);
        return <div className="flex-row gap-large"> 
        
        <button className="w-button w-button-secondary"  onClick={()=>{onDismiss&&onDismiss()}}>Cancel</button>
        <button disabled={disabled} style={disabled?{opacity:".5",pointerEvents:"none"}:{}} className="w-button w-button-primary " onClick={()=>{

                Confirmation("Are you sure you want to restore this version? This will overwrite your current site.",()=>{

             
                if(selectedVersion){
                    setIsLoading(true);
                RestoreHistory(siteData.userContext,selectedVersion,(data)=>{

                    window.location.reload();
                
            
                },(err)=>{
                    setIsLoading(false);
                    AlertConfirm("Error","There was an error restoring this version, please try again later");
                })

            }
        },()=>{
            setIsLoading(false);

        },"restoreVersionConfirmation","Restore Version","Restore","Cancel");
        }

        }> Restore
           
            </button>
         </div>
    }
    
    const NoHistoryScreen = ()=>{
return    <div className="w-full h-full center-all font-large"><div style={{marginBottom:"8px"}} className="flex-column gap-med align-center">
    <svg xmlns="http://www.w3.org/2000/svg" height="2.5em" viewBox="0 0 512 512" fill="#333"><path d="M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"/></svg>
    <div className="font-large " style={{fontWeight:"700"}}>No History Available</div>
    <div className="font-small">You have not published your website in the last 3 months.</div>
    </div>
</div>


    }


    
    return <>
        <div className="block-edit fast-fade center-all h-full w-full" style={{position:"fixed",top:"0",left:"0",padding:"32px",background:"rgba(0,0,0,0.5)",zIndex:2000}}>
            {isLoading&&<Loader/>}
            <div className="flex-column"  style={{position:"relative",padding:"16px 20px",background:"white",borderRadius:"6px",width:"100%",height:"100%"}} >
                <div className="w-full  flex-row" style={{height:"calc(100% - 64px)", minHeight:"calc(100% - 64px)"}}>
                    <ScreenSizeSelector key="tester"/>
                    <PageSelector/>
                    <button onClick={()=>{onDismiss&&onDismiss()}} className="invisible-button center-all font-bold" style={{fontFamily:"'proxima-nova'", width:"32px",height:"32px",color:"#333",background:"white",zIndex:"300",fontSize:"2em", position:"absolute",right:"16px",top:"12px"}}>&times;</button>
            
                    <div key="history-list-column" className="flex-column h-full" style={{zIndex:50,width:"240px",minWidth:"240px",borderRight:"1px solid #E7E7E7"}} >
                        <div className="center-all"  style={{height:"50px",padding:"0 8px"}}>
                            <h4 className="w-full" style={{margin:"8px"}}>Version History</h4>
                        </div> 
                        <div className="h-full scrollable" style={{padding:"0px 12px"}} >
                        {versionData===null&&<Loader/>}
                        {versionData!=null&&versionData!="error"&&<HistoryList versionData={versionData} selectedVersion={selectedVersion} siteData={siteData} loadHistoryByVersion={loadHistoryByVersion}/>}
                        {versionData==="error"&&<div>There was an error loading the history</div>}

                    </div>
                </div>
                <div className="w-full h-full" style={{overflow:"hidden",maxWidth:"100%",padding:"48px 0px 0px 0px"}}>
                    <div className="w-full h-full center-all" style={{maxWidth:"100%"}}>
                    {versionData&&versionData.length==0&& <NoHistoryScreen/>
                    }
                    {loadedData==="loading"&&<div className="w-full h-full center-all"><Loader/></div>}
                    {loadedData!="loading"&&loadedData!="error"&&loadedData!=null&&
                    
                    <> 
                    <HistoryPreviewScreen pageId={loadedPageId}/>
                    </>
                    }
                </div>
                
         
            </div>
            
                </div>
            <div className="flex-row justify-end h-full" style={{paddingTop:"16px"}}>
            <RestoreButton/>
            </div>
            </div>
        </div>
    
    </>

}